import { DatePickerInput } from '@components/_SiteWide/Form/DatePickerInput'
import { DropdownSelect } from '@components/_SiteWide/Form/DropdownSelect'
import { handleSubmit } from '@components/Admin/TankTransition/helpers'
import {
  DataItem,
  ErrorNotification,
  GraviButton,
  GraviGrid,
  Horizontal,
  Texto,
  Vertical,
} from '@gravitate-js/excalibrr'
import { Drawer, Form } from 'antd'
import React, { useMemo, useState } from 'react'
import { formatters } from '@utils/intl/dateTimeFormatters'

export function BulkChangeDrawer({
  setIsBulkChangeVisible,
  isBulkChangeVisible,
  columnDefs,
  selectedRows,
  refreshAndDeselect,
  productNames,
}) {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState()
  const drawerColumnDefs = useMemo(() => {
    const columnCopy = [...columnDefs]
    columnCopy[0] = {
      ...columnCopy[0],
      checkboxSelection: false,
      headerCheckboxSelection: false,
      headerCheckboxSelectionFilteredOnly: false,
    }
    columnCopy.pop()
    return columnCopy
  }, [columnDefs])

  const onFinish = () => {
    setIsBulkChangeVisible(false)
    refreshAndDeselect()
    setLoading(false)
  }
  return (
    <Drawer
      placement='bottom'
      onClose={() => setIsBulkChangeVisible(false)}
      open={isBulkChangeVisible}
      title='Bulk Tank Transition'
      height='80vh'
      styles={{ body: { padding: '0px', background: 'var(--bg-3)' } }}
      destroyOnClose
    >
      <Form
        onFinish={(formData) => {
          setLoading(true)
          handleSubmit(formData, selectedRows, onFinish)
        }}
        form={form}
        style={{ height: '100%' }}
        onFinishFailed={ErrorNotification}
      >
        <Vertical flex='1'>
          <div className='p-3  bg-theme2 bg-3'>
            <Texto category='p2' appearance='white'>
              <b>Selected Tanks - </b> You have selected the following rows to transition:
            </Texto>
          </div>
          <div className='p-3' style={{ flex: 1 }}>
            <GraviGrid
              controlBarProps={{
                title: 'Selected Rows',
              }}
              agPropOverrides={{
                columnDefs: drawerColumnDefs,
                getRowId: (row) => row.data?.key,
              }}
              sideBar={false}
              rowGroupPanelShow='never'
              storageKey='tank-strategy-bulk-change'
              rowData={selectedRows}
            />
          </div>
          <div
            style={{ background: 'var(--bg-3)', width: 1200, alignSelf: 'center' }}
            className=' bordered round-border p-3 m-3'
          >
            <Texto category='heading' appearance='secondary'>
              Transition Changes
            </Texto>
            <Horizontal>
              <Vertical verticalCenter horizontalCenter flex={1}>
                <DataItem label='Dispatch Product'>
                  <DropdownSelect
                    required
                    name='updated_dispatch_product'
                    message='Dispatch Product is required'
                    style={{ minWidth: 150 }}
                    editable
                    options={productNames?.sort()}
                  />
                </DataItem>
              </Vertical>

              <Vertical className='ml-3' horizontalCenter verticalCenter flex={1}>
                <DataItem label='Dispatch Effective'>
                  <DatePickerInput
                    required
                    editable
                    placement='topRight'
                    name='updated_dispatch_date'
                    style={{ minWidth: 150 }}
                    message='Dispatch From is required'
                    format={formatters.DATE}
                  />
                </DataItem>
              </Vertical>
              <Vertical className='ml-3' verticalCenter horizontalCenter flex={1}>
                <DataItem label='Customer Product'>
                  <DropdownSelect
                    required
                    name='updated_customer_product'
                    message='Customer Product is required'
                    style={{ minWidth: 150 }}
                    editable
                    options={productNames?.sort()}
                  />
                </DataItem>
              </Vertical>
              <Vertical className='ml-3' verticalCenter flex={1}>
                <DataItem label='Customer Effective'>
                  <DatePickerInput
                    style={{ minWidth: 150 }}
                    required
                    editable
                    name='updated_customer_date'
                    message='Customer From is required'
                    format={formatters.DATE}
                  />
                </DataItem>
              </Vertical>
            </Horizontal>
          </div>
          <Vertical flex='0' justifyContent='flex-end' style={{ minHeight: 70 }}>
            <Horizontal verticalCenter className='p-3 bg-3'>
              <Texto style={{ flex: 1 }} category='p2' weight='bold'>
                <b>Save Bulk Change</b>
              </Texto>
              <GraviButton className='mr-3' buttonText='Cancel' onClick={() => setIsBulkChangeVisible(false)} />
              <GraviButton theme2 buttonText='Save Bulk Changes' loading={loading} onClick={form.submit} />
            </Horizontal>
          </Vertical>
        </Vertical>
      </Form>
    </Drawer>
  )
}
